<template>
  <UiTheHeader />
  
  <UiTheCover />

  <UiArticleBody class="culture-post__article-body">
    <UiArticleIndex
      :isIndexActive="isIndexActive"
      @closeIndex="handleIndexActive(false)"
      @openIndex="handleIndexActive(true)"
    />
    <div class="share-wrapper">
      <UiShareFacebook />
      <UiShareLine />
    </div>
  </UiArticleBody>

  <GptAd />

  <UiWineWarning />
</template>

<script>
import './base.css'

import GptAd from './components/GptAd.vue'
import UiArticleBody from './components/UiArticleBody.vue'
import UiArticleIndex from './components/UiArticleIndex.vue'
import UiShareFacebook from './components/UiShareFacebook.vue'
import UiShareLine from './components/UiShareLine.vue'
import UiTheCover from './components/UiTheCover.vue'
import UiTheHeader from './components/UiTheHeader.vue'
import UiWineWarning from './components/UiWineWarning.vue'

export default {
  name: 'App',
  components: {
    GptAd,
    UiArticleBody,
    UiArticleIndex,
    UiShareFacebook,
    UiShareLine,
    UiTheCover,
    UiTheHeader,
    UiWineWarning
  },
  data() {
    return {
      isIndexActive: false,
      viewportWidth: 0
    }
  },
  mounted() {
    this.updateViewport()
    window.addEventListener('resize', this.updateViewport)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewport)
  },
  watch: {
    viewportWidth(value) {
      if (value >= 1200) {
        this.isIndexActive = false
      }
    },
  },
  methods: {
    handleIndexActive(isActive) {
      this.isIndexActive = isActive
    },
    updateViewport() {
      this.viewportWidth = window.innerWidth
    }
  }
}
</script>

<style lang="scss" scoped>
.culture-post {
  color: rgba(#000, 0.87);
  word-break: break-word;
  overflow-wrap: break-word;

  &__article-body {
    margin: 40px 0 0;
    @media screen and (min-width: 768px) {
      padding-left: 0;
      padding-right: 0;
      margin-left: auto;
      margin-right: auto;
      max-width: 700px;
    }
  }
}

.share-wrapper {
  display: flex;
  padding: 0 5%;
  a + a {
    margin-left: 10px;
  }
  @media screen and (min-width: 996px) {
    display: none;
  }
}

</style>
